import { PageEvent } from "@angular/material/paginator";

export class CustomPaginatorEvent extends PageEvent {
    retrieveNewPage: boolean;
    pageSizeIndex: number;
    maxPageSize: number;
  }